/**
 * Discriminates which distro review workflow pipeline wrote/is scoped to a row in
 * applicantinfo_simulated / applicantinfo_snapshot for a given distro_commit_id: the
 * sample/snapshot-backed pipeline (data_snapshot -> data_snapshot_simulated ->
 * roboscreener_simulation -> target_fields / notifications) vs. the fast, always-on "delta"
 * pipeline (delta_roboscreener_simulation -> delta_target_fields / delta_notifications).
 *
 * Lives in @aidkitorg/types (rather than aidkit's distroReview.ts, where the workflow names
 * themselves live) so it can be imported by both aidkit and roboscreener without a circular or
 * cross-package dependency -- both already depend on @aidkitorg/types.
 */
export const PIPELINE = {
  SAMPLED: 'sampled',
  DELTA: 'delta',
} as const;

export type Pipeline = typeof PIPELINE[keyof typeof PIPELINE];
